import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import classNames from 'classnames';

var Disclaimer = function Disclaimer(_ref) {
  var Tag = _ref.tag,
      classes = _ref.className,
      styled = _ref.styled,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["tag", "className", "styled", "children"]);

  return React.createElement(Tag, Object.assign({
    "data-testid": "disclaimer",
    className: classNames(classes, {
      disclaimer: styled
    }, {
      'disclaimer-unstyled': !styled
    })
  }, rest), children);
};

Disclaimer.defaultProps = {
  tag: 'div',
  styled: true
};
export default Disclaimer;